import * as React from 'react';
import { SidebarWidget } from '../sidebar/SidebarWidget';
import { styled } from '../../theme';
import { SidebarItem } from '../../routes';
import { PropsWithChildren } from 'react';
import { getScrollbarCss } from './scroll';

export interface SidebarLayoutWidgetProps {
  items: SidebarItem[];
  activeItemKey?: string;
  className?: any;
  padding?: boolean;
}

const SidebarLayout: React.FC<PropsWithChildren<SidebarLayoutWidgetProps>> = (props) => {
  const getSidebar = (): JSX.Element | null => {
    if (props.items.length > 0) {
      return <SidebarWidget {...props} />;
    }
    return null;
  };

  return (
    <S.Container className={props.className}>
      {getSidebar()}
      <S.Content>{props.children}</S.Content>
    </S.Container>
  );
};

namespace S {
  export const Container = styled.div`
    display: flex;
    position: relative;
    height: 100%;
    max-height: 100%;
    * {
      ${(p) => getScrollbarCss(p.theme)};
    }
  `;

  export const Content = styled.div`
    display: flex;
    flex-grow: 1;
    overflow-y: auto;
  `;
}

export const SidebarLayoutWidget = SidebarLayout;
